import React from 'react';
import _ from 'underscore';

import {Permissions} from 'auth/PermissionConstants';
import DataConnector from 'connect/DataConnector';
import ReviewConstants from 'notebook/reviews/ReviewConstants';
import {ItemVersionState} from 'notebook/store/VersionedItemSubstore';
import HistoryPanelComponent from 'toolbar/shared/HistoryPanelComponent';
import * as StageEntryActions from 'workflows/stage-entries/StageEntryActions';
import StageEntryStore, {StageEntryStoreVersion} from 'workflows/stage-entries/StageEntryStore';
import {isFirstTrackedVersion} from 'workflows/stage-entries/StageEntryUtil';

interface StageEntryHistoryPanelProps {
  id: string;
  permissions: Permissions;
}

class StageEntryHistoryPanelConnector extends DataConnector<
  StageEntryHistoryPanelProps,
  ItemVersionState<StageEntryStoreVersion>
> {
  override stores = [StageEntryStore];

  enhanceProps(): ItemVersionState<StageEntryStoreVersion> {
    return StageEntryStore.getVersionState(this.props.id);
  }
}

class StageEntryHistoryPanel extends React.Component<
  StageEntryHistoryPanelProps & ItemVersionState<StageEntryStoreVersion>
> {
  override componentDidMount(): void {
    StageEntryActions.fetchVersions(this.props.id);
  }

  override componentDidUpdate(
    prevProps: StageEntryHistoryPanelProps & ItemVersionState<StageEntryStoreVersion>
  ): void {
    if (prevProps.savedVersion !== this.props.savedVersion || prevProps.id !== this.props.id) {
      // Avoid flux nested-dispatch issues
      _.defer(() => {
        StageEntryActions.fetchVersions(this.props.id);
      });
    }
  }

  openVersion = (versionId: number): void => {
    StageEntryActions.loadVersion(this.props.id, versionId);
  };

  override render(): JSX.Element {
    // Invariant: history panel is only rendered if the entry has been loaded into the store
    const entry = StageEntryStore.getEntry(this.props.id)!;
    return (
      <HistoryPanelComponent
        openVersion={this.openVersion}
        versions={this.props.versions}
        openVersionId={this.props.openVersionId === false ? undefined : this.props.openVersionId}
        dirty={this.props.dirty}
        isLockedForReview={
          entry.review ? ReviewConstants.LOCKED_STATUSES.includes(entry.review.status) : false
        }
        isLatest={this.props.isLatest}
        isFirstTrackedVersion={isFirstTrackedVersion}
        unsaved={this.props.unsaved}
        hasParent={this.props.hasParent}
        parent={this.props.parent}
        permissions={this.props.permissions}
      />
    );
  }
}

export default StageEntryHistoryPanelConnector.connect(StageEntryHistoryPanel);
